<template>
  <section v-if="references.length" class="container relative grid grid-cols-12 mx-auto px-4">
    <div class="col-span-full 2xl:col-end-10 2xl:col-start-4 px-6 py-10 bg-app-green rounded-b-lg md:px-12 lg:col-end-12 lg:col-start-2 lg:px-24 xl:col-end-11 xl:col-start-3">
      <h3 class="mb-4 text-black text-lg font-bold uppercase">Meer over dit onderwerp</h3>

      <div class="grid gap-x-20 gap-y-8 grid-cols-1 md:grid-cols-2">
        <div v-for="(reference, key) in references" :key="key" class="group text-lg">
          <AtomLink :url="reference.url">
            <h4 class="font-bold text-black">
              {{ reference.title }}
              <AtomIconArrowRight v-if="!reference.subtitle" class="inline-block ml-2 w-3 text-white transform group-hover:translate-x-1 transition duration-200" />
            </h4>
            <article v-if="reference.subtitle" class="inline-block border-b border-white cursor-pointer">
              {{ reference.subtitle }}
              <AtomIconArrowRight class="inline-block ml-2 w-3 text-white transform group-hover:translate-x-1 transition duration-200" />
            </article>
          </AtomLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
interface Props {
  references: {
    url: string
    title: string
    subtitle?: string
  }[]
}
defineProps<Props>()
</script>
